import { ActionTypes } from './actions';
import { ExamInitialState } from './state';
import { Quiz, Question } from '../../scenes/Students/EntranceExam/EntranceExam';
// interface ExamAction {
//   type: string;
//   payload: Quiz;
// }

const randomAndRemainingQuestions = (quiz: Quiz) => {
  const remainingQuestions = quiz.questions.filter((question: Question) => {
    return !quiz.previouslyAttemptedQuestions.includes(question.id);
  });
  return remainingQuestions.sort(() => Math.random() - 0.5);
}

export default function entranceExam(state: any = ExamInitialState, action: any) {

  switch (action.type) {
    case ActionTypes.FETCH_ENTRANCE_QUIZ:
      const quiz = { ...action.payload };
      quiz.questions = randomAndRemainingQuestions(quiz);
      return {
        ...state,
        quizzes: quiz
      }
    case ActionTypes.ENTRANCE_QUIZ_SAVE:
      return {
        ...state,
        // quizzes: action.payload
      }
    default:
      return { ...state };
  }
}